import { useRouter } from 'next/navigation';

import { useCallback } from 'react';

import { urlHelpers } from '@nocowanie/core/helpers';

import { mapSearchStateToUrlParams } from '@app/helpers/search-params.helpers';
import { useSearch } from '@app/hooks/useSearch';

export const useMapRedirect = () => {
    const router = useRouter();
    const { searchCriteria, filters } = useSearch();

    return useCallback(() => {
        const params = mapSearchStateToUrlParams(searchCriteria || {}, filters || {});
        const redirectUrl = urlHelpers.getMapUrl(params);

        router.push(redirectUrl);
    }, [searchCriteria, filters, router]);
};
